import cx from 'classnames';
import * as React from 'react';

import style from './HtmlContent.module.css';

interface Props {
    className?: string;
    htmlContent: string;
}

export function HtmlContent({ className, htmlContent }: Props) {
    return (
        <div
            className={cx(style.content, className)}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
    );
}
